import React, { Fragment } from "react";
import { Participant, CategoryTag, Locale } from "../../core/api/model";
import { DashboardFavouritesParticipantsListItem, DashboardFavouritesListEmpty } from ".";

export interface DashboardFavouritesParticipantsListProps {
  locale: Locale;
  participants: Participant[];
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesParticipantsList = (props: DashboardFavouritesParticipantsListProps) => {
  return props.participants.length > 0 ? (
    // list
    <Fragment>
      {props.participants.map((participant: Participant) => 
        <DashboardFavouritesParticipantsListItem key={participant.partId}
                                                locale={props.locale}
                                                participant={participant}
                                                deleteFavourite={props.deleteFavourite}
        />
      )}
    </Fragment>
  ) :
  // empty
  <DashboardFavouritesListEmpty />;
};
